/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useContext, createContext, useEffect, useState, useMemo } from "react";
import { useQuoter } from "../api/quoterApi";
import { boolIsTrue, getAge, valusIsTrue } from "../helpers/toolsHelper";
import { useDate } from "../hooks/cotizador/DateHook";
import { getEnvVariables } from "helpers/getEnvVariables";
import { DEPENDENT_RELATIONSHIPS, GEO_VALIDATION } from "constants/validationConstants";
import { useAuth } from "./userContext";
import { useCoverageSelection } from "hooks/useCoverageSelection";
import { mapFavoritePlanToQuoteContext } from "helpers/FavoritePlanToQuote";
import {
    CHANGE_DATA,
    CHANGE_BENEFIT,
    CHANGE_BENEFIT_NAME,
    CHANGE_BENEFIT_ID,
    REMOVE_BENEFITS,
    ADD_CALCULATION,
    SET_CALCULATION_ERROR,
    POPULATE_CONTEXT,
    LOAD_DATA,
    createQuoteFormInitialState,
    quoteFormReducer,
} from "./quoteFormState";


const ApiContext = createContext();

const CHANGE_DEPENDANT_DATA = "cotizador-change_dependant_data";
const RESET_DEPENDANT_DATA = "cotizador-reset_dependant_data";
const ADD_DEPENDANT = "cotizador-add_dependant";
const REMOVE_DEPENDANT = "cotizador-remove_dependant";
const EDIT_DEPENDANT = "cotizador-edit_dependant";
const START_EDIT_DEPENDANT = "cotizador-start_edit_dependant";
const RESET_DATA = "cotizador-reset_data";
const EDIT_DEPENDANT_TRAVEL = "cotizador-edit_dependant--travel";
const SYNC_DEPENDANTS_COUNTRY = "cotizador-sync_dependants_country";

export const FEMALE_BENEFITS = [
    // "Maternity and cesarean",
    "matrnity"
];
export const OUTPATION_BENEFITS = [
    "compther",
    // "Prescribed medications",
    // "Mental health prescription medication",
    // "Refractive eye surgery",
    "mxoutcov"
];

const initialState = createQuoteFormInitialState({
    step: 0,
    total: 0,
    maximun: false,
    step15Confirmation: false,
});

const cotizador = (state, action) => {
    switch (action.type) {
        case CHANGE_DEPENDANT_DATA:
            return { ...state, dependantData: { ...state.dependantData, [action.payload.name]: action.payload.value } };
        case ADD_DEPENDANT:
            state.dependantData.id = state.dependants.length;
            return { ...state, dependants: [...state.dependants, state.dependantData] };
        case REMOVE_DEPENDANT:
            return {
                ...state,
                dependants: state.dependants
                    .filter(i => i.id !== action.payload)
                    .map((i, index) => ({ ...i, id: index }))
            };
        case EDIT_DEPENDANT:
            return {
                ...state, dependants: state.dependants.map(i => {
                    if (i.id === state.dependantData.id) return state.dependantData;
                    return i;
                })
            };
        case EDIT_DEPENDANT_TRAVEL:
            return {
                ...state, dependants: state.dependants.map(i => {
                    if (i.id === action.payload.id) return { ...i, travel: action.payload.travel };
                    return i;
                })
            };
        case SYNC_DEPENDANTS_COUNTRY:
            return {
                ...state,
                dependants: state.dependants.map(i => ({ ...i, country: action.payload.country }))
            };
        case START_EDIT_DEPENDANT:
            return { ...state, dependantData: state.dependants.find(i => i.id === action.payload) };
        case RESET_DEPENDANT_DATA:
            return { ...state, dependantData: initialState.dependantData };
        case RESET_DATA:
            return initialState;
        default:
            return quoteFormReducer(state, action);
    }
};

export function useCotizador() {
    return useContext(ApiContext);
}

export function ApiProvider({ children }) {
    const [contextState, dispatch] = React.useReducer(cotizador, initialState);
    const calculationValue = useMemo(() => contextState.calculation, [contextState.calculation]);
    const [errors, setErrors] = React.useState({});
    const [benefitErrors, setBenefitErrors] = React.useState({});
    const [maximun, setMaximun] = React.useState(0);
    // eslint-disable-next-line no-unused-vars
    const [maximunOutpatient, setMaximunOutpatient] = React.useState(0);
    const [calculation, setCalculation] = useState(null);
    const quora = useQuoter(contextState);
    const [show, setShow] = useState(false);
    const { clearApQuoteId } = useAuth();
    const { DEBUG } = getEnvVariables();

    useEffect(() => {
        if (localStorage.getItem('coContext') && DEBUG) {
            dispatch({ type: LOAD_DATA, payload: JSON.parse(localStorage.getItem('coContext')) })
        }
    }, [])

    const changeDataValue = (name, value) => {
        dispatch({ type: CHANGE_DATA, payload: { name, value } });
    }

    const changeBenefitValue = (name, value) => {
        dispatch({ type: CHANGE_BENEFIT, payload: { name, value } });
    }

    const changeBenefitNameValue = (name, value) => {
        dispatch({ type: CHANGE_BENEFIT_NAME, payload: { name, value } });
    }

    const changeBenefitIdValue = (name, value) => {
        dispatch({ type: CHANGE_BENEFIT_ID, payload: { name, value } });
    }

    const {
        benefits,
        ignoredBenefits,
        setIgnoredBenefits,
        preferreds,
        getAllBenefits,
        handleOnChangeBenefit,
        calculateSelectedItem,
    } = useCoverageSelection({
        selectedBenefits: contextState.selectedBenefits,
        selectedBenefitsIds: contextState.selectedBenefitsIds,
        selectedBenefitsNames: contextState.selectedBenefitsNames,
        dependants: contextState.dependants,
        addDependant: contextState.addDependant,
        country: contextState.country,
        isCountryResidenceDeductible: contextState.isCountryResidenceDeductible,
        hasLoadedQuoteContext: contextState.hasLoadedQuoteContext,
        isCountryResidenceDeductibleFlagPresent: contextState.isCountryResidenceDeductibleFlagPresent,
        changeBenefitValue,
        changeBenefitNameValue,
        changeBenefitIdValue,
    });

    const isEverythingLoading = () => {
        const {
            organRiderQuery,
        } = quora;

        const {
            regular,
            structural
        } = benefits;

        if (
            organRiderQuery.isLoading ||
            regular.isLoading ||
            structural.isLoading
        ) {
            return true;
        }

        if (
            organRiderQuery.error ||
            regular.error ||
            structural.error
        ) {
            return true;
        }

        return false;

    }

    const isFemale = () => {
        const userIsFemale = 18 <= getAge(contextState.birthday) && getAge(contextState.birthday) <= 43 && contextState.gender == 2;
        const dependantIsFemale = contextState.dependants.find((dependant) => 18 <= getAge(dependant.birthday) && getAge(dependant.birthday) <= 43 && dependant.gender == 2 && dependant.componentId === DEPENDENT_RELATIONSHIPS.SPOUSE);

        return userIsFemale || (dependantIsFemale && boolIsTrue(contextState.addDependant));
    }

    useEffect(() => {
        const isWorldwide = contextState?.selectedBenefits?.geogrcov === GEO_VALIDATION.WORLDWIDE;
        const isGlobalOpen = contextState?.selectedBenefitsIds?.provdnet === GEO_VALIDATION.PROVIDER_GLOBAL_OPEN;

        changeDataValue('acceptNonRegion', isWorldwide && isGlobalOpen);

    }, [
        contextState.selectedBenefits?.geogrcov,
        contextState.selectedBenefitsIds?.provdnet
    ]);

    const changeDependantValue = (name, value) => {
        dispatch({ type: CHANGE_DEPENDANT_DATA, payload: { name, value } });
    }

    const addDependantToList = () => {
        dispatch({ type: ADD_DEPENDANT });
    }

    const resetDependantData = () => {
        setErrors({ ...errors, dependants: {} });
        dispatch({ type: RESET_DEPENDANT_DATA });
        dateHandler.setDates({ ...dateHandler.dates, dependantB: "" })
    }

    const resetData = () => {
        dateHandler.resetDates();
        dispatch({ type: RESET_DATA });
        clearApQuoteId();
    }

    const deleteDependant = (dependantId) => {
        dispatch({ type: REMOVE_DEPENDANT, payload: dependantId });
    }

    const startEdit = (dependantId) => {
        dispatch({ type: START_EDIT_DEPENDANT, payload: dependantId });
        let dateBirthDependent = contextState.dependants.find(i => i.id == dependantId).birthday
        dateHandler.setDates({ ...dateHandler.dates, dependantB: new Date(`${dateBirthDependent}T00:00:00-05:00`) })
    }

    const editDependant = () => {
        dispatch({ type: EDIT_DEPENDANT });
    }

    const addCalculation = (payload) => {
        dispatch({ type: ADD_CALCULATION, payload });
    };

    const addCalculationError = () => {
        dispatch({ type: SET_CALCULATION_ERROR });
    };

    const removeBenefits = (name) => {
        dispatch({ type: REMOVE_BENEFITS, payload: { name } });
    };

    const populateContext = (payload) => {
        dispatch({ type: POPULATE_CONTEXT, payload });
        dateHandler.setDates({ ...dateHandler.dates, birthday: new Date(`${payload.birthday}T00:00:00-05:00`), coverage: new Date(`${payload.coverage}T00:00:00-05:00`) })
    };

    /**
     * Arranca una cotización nueva a partir de un plan favorito ("use" en el dashboard).
     *
     * Se resetea primero para no arrastrar una cotización en curso; `resetData` además
     * limpia el apQuoteId, sin lo cual `usePopulateHook` traería la cotización vieja al
     * llegar a Step1. No se reutiliza `populateContext` porque éste construye fechas a
     * partir del payload, y aquí el template no aporta birthday ni coverage (los llena
     * el agente): quedarían como Invalid Date. Las fechas se quedan como las dejó
     * `resetDates()`.
     *
     * `myFavoritePlanId` (el id del template) se guarda en el contexto para reenviarlo a
     * `/rate-engine/compute` y rastrear de qué template salió la cotización.
     *
     * No sanea el estado: TableSection ya revalidó el plan contra
     * `/rate-engine/compute` (ver helpers/FavoritePlanValidation.js) antes de llamar
     * acá, así que si `applyFavoritePlan` se está ejecutando es porque el compute ya
     * confirmó que el plan, tal cual está, sigue siendo cotizable.
     */
    const applyFavoritePlan = (planData, myFavoritePlanId = null) => {
        const quoteContext = mapFavoritePlanToQuoteContext(planData);

        resetData();
        dispatch({
            type: POPULATE_CONTEXT,
            payload: { ...quoteContext, myFavoritePlanId },
        });
    };

    const editDependantTravel = (id, travel) => {
        dispatch({ type: EDIT_DEPENDANT_TRAVEL, payload: { id, travel } });
    }

    const syncDependantsCountry = (country) => {
        dispatch({ type: SYNC_DEPENDANTS_COUNTRY, payload: { country } });
    }

    const handleOnChange = async (e, meta = null) => {
        const name = e?.target?.name ?? meta?.name;
        const value = e?.target?.value ?? e?.value;
        await changeDataValue(name, value);
    }

    const handleOnChangeDependant = async (e, meta = null) => {
        const name = e?.target?.name ?? meta?.name;
        const value = e?.target?.value ?? e?.value;
        await changeDependantValue(name, value);
    }

    const handleChecks = (e) => {
        handleOnChange({ target: { value: e.target.checked, name: e.target.name } })
    }

    const thereIsTravel = () => {
        return [valusIsTrue(contextState.travel), ...contextState.dependants.map(i => valusIsTrue(i.travel))].some(i => !!i);
    }

    const dateHandler = useDate(changeDependantValue, changeDataValue);




    // Mismo mecanismo que MyFavoritePlanFormContext.hasUnsavedChanges: compara el
    // estado actual contra el inicial para decidir si el back to home debe pedir
    // confirmación o puede navegar directo.
    const hasUnsavedChanges = JSON.stringify(contextState) !== JSON.stringify(initialState);

    const value = {
        ...contextState,
        ...quora,
        ...benefits,
        contextState,
        hasUnsavedChanges,
        handleChecks,
        isFemale,
        changeDataValue,
        resetData,
        handleOnChange,
        handleOnChangeBenefit,
        addDependantToList,
        changeDependantValue,
        handleOnChangeDependant,
        resetDependantData,
        editDependant,
        editDependantTravel,
        syncDependantsCountry,
        deleteDependant,
        startEdit,
        thereIsTravel,
        quora,
        benefits,
        calculation,
        setCalculation,
        addCalculation,
        addCalculationError,
        removeBenefits,
        populateContext,
        applyFavoritePlan,
        calculationValue,
        errors,
        setErrors,
        show,
        setShow,
        ignoredBenefits,
        setIgnoredBenefits,
        ...dateHandler,
        maximun,
        isEverythingLoading,
        benefitErrors,
        setBenefitErrors,
        calculateSelectedItem,
        preferreds,
        getAllBenefits
    };


    return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}

export default ApiContext;
